// If none of the labels match or there is no formGroup on the column, it renders it in section "other" (inne) in the AddNewEntry dialog.
export const formGroupLabel: Record<string, string> = {
  origin: "Załadunek",
  delivery: "Dostawa",
  destination: "Rozładunek",
};
